// Keep the poster and booking path usable even when video cannot play.
const heroVideo = document.querySelector('#hero-video');
const heroCover = document.querySelector('.hero-film-cover');
const heroStatus = document.querySelector('.hero-film-status');
const heroDirect = document.querySelector('.hero-film-direct');
if (heroVideo && heroCover && heroStatus && heroDirect) {
  const playbackButton = document.createElement('button');
  playbackButton.type = 'button';
  playbackButton.className = 'hero-playback';
  playbackButton.hidden = true;
  playbackButton.setAttribute('aria-controls', 'hero-video');
  heroVideo.parentElement.append(playbackButton);
  heroVideo.controls = false;
  const syncPlayback = () => {
    const paused = heroVideo.paused;
    playbackButton.dataset.paused = String(paused);
    playbackButton.setAttribute('aria-label', paused ? 'Play studio video' : 'Pause studio video');
    playbackButton.innerHTML = `<span aria-hidden="true">${paused ? '▶' : 'Ⅱ'}</span><span>${paused ? 'Play' : 'Pause'}</span>`;
  };
  syncPlayback();
  heroCover.hidden = false;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const conserveData = connection?.saveData || /(^|-)2g$|^3g$/.test(connection?.effectiveType || '');
  const sources = [...heroVideo.querySelectorAll('source')];
  const failedSources = new Set();
  let heroTimer, inView = false, attempted = false, pausedForVisibility = false, manuallyPaused = false;
  let hasPlayed = false, loading = false, unavailable = false, playRequest = 0;
  const directSource = () => {
    const preferred = sources.find(source => !source.media || matchMedia(source.media).matches);
    heroDirect.href = heroVideo.currentSrc || preferred?.src || heroDirect.href;
  };
  const clearStatus = () => {
    clearTimeout(heroTimer); heroStatus.hidden = true; heroDirect.hidden = true;
  };
  const failed = () => {
    playbackButton.hidden = true;
    clearStatus(); loading = false; unavailable = true;
    heroCover.hidden = false;
    heroStatus.textContent = 'Video unavailable. You can retry or open it separately.';
    heroStatus.hidden = false; heroDirect.hidden = false;
    directSource();
  };
  const watchLoading = () => {
    clearTimeout(heroTimer);
    heroTimer = setTimeout(() => {
      if (!loading) return;
      heroStatus.textContent = 'Taking a little longer to load. You can still browse and book.';
      heroStatus.hidden = false; heroDirect.hidden = false;
      directSource();
    }, 8000);
  };
  const play = (explicit = false) => {
    if (loading && !explicit) return;
    const request = ++playRequest;
    attempted = true; manuallyPaused = false;
    clearStatus();
    if (unavailable || heroVideo.error || (explicit && heroVideo.readyState < 2)) {
      unavailable = false; failedSources.clear(); heroVideo.load();
    }
    loading = true;
    if (explicit) { heroStatus.textContent = 'Loading video…'; heroStatus.hidden = false; }
    watchLoading();
    heroVideo.play()?.catch(error => {
      if (request !== playRequest) return;
      loading = false;
      if (error.name === 'NotAllowedError' || error.name === 'AbortError') {
        clearStatus(); heroCover.hidden = !heroVideo.paused;
      } else failed();
    });
  };
  heroCover.addEventListener('click', () => play(true));
  const togglePlayback = () => {
    if (heroVideo.paused) play(true);
    else { manuallyPaused = true; pausedForVisibility = false; heroVideo.pause(); }
  };
  playbackButton.addEventListener('click', togglePlayback);
  heroVideo.addEventListener('click', togglePlayback);
  heroVideo.classList.add('click-to-pause');
  heroVideo.addEventListener('playing', () => {
    loading = false; hasPlayed = true; pausedForVisibility = false; manuallyPaused = false;
    playbackButton.hidden = false;
    syncPlayback();
    if (document.activeElement === heroCover) playbackButton.focus();
    heroCover.hidden = true; clearStatus(); directSource();
  });
  heroVideo.addEventListener('pause', () => {
    syncPlayback();
    loading = false; clearTimeout(heroTimer);
    if (!pausedForVisibility && hasPlayed) manuallyPaused = true;
  });
  heroVideo.addEventListener('waiting', () => { loading = true; watchLoading(); });
  heroVideo.addEventListener('error', failed);
  sources.forEach(source => source.addEventListener('error', () => {
    failedSources.add(source);
    const eligible = sources.filter(item => !item.media || matchMedia(item.media).matches);
    if (eligible.every(item => failedSources.has(item))) failed();
  }));
  const pauseOffscreen = () => {
    if (!heroVideo.paused) { pausedForVisibility = true; heroVideo.pause(); }
  };
  const updatePlayback = () => {
    if (!inView || document.hidden) { pauseOffscreen(); return; }
    if (pausedForVisibility && !manuallyPaused && !motion.matches) play();
    else if (!attempted && !motion.matches && !conserveData) play();
  };
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      updatePlayback();
    }, { threshold: 0.1 }).observe(heroVideo);
  } else { inView = true; updatePlayback(); }
  document.addEventListener('visibilitychange', updatePlayback);
  motion.addEventListener('change', () => {
    if (motion.matches) pauseOffscreen();
    else updatePlayback();
  });
}
// Progressive enhancement: original testimonials remain readable without JS.
const reviews = document.querySelector('.student-voices');
if (reviews) {
  const cards = [...reviews.querySelectorAll('figure')];
  reviews.querySelector('.eyebrow').textContent = 'THE HIT EXPERIENCE · SELECTED REVIEWS';
  const viewport = document.createElement('div');
  viewport.className = 'reviews-viewport';
  viewport.id = 'student-review-slides';
  viewport.setAttribute('role', 'group');
  viewport.tabIndex = 0;
  viewport.setAttribute('aria-label', 'Student reviews. Swipe horizontally or use left and right arrow keys to browse.');
  const track = document.createElement('div');
  track.className = 'reviews-track';
  track.append(...cards);
  viewport.append(track);
  reviews.append(viewport);
  reviews.setAttribute('aria-roledescription', 'carousel');
  const controls = document.createElement('nav');
  controls.className = 'reviews-controls';
  controls.setAttribute('aria-label', 'Review carousel controls');
  const button = (label, text, action) => {
    const el = document.createElement('button');
    el.type = 'button'; el.setAttribute('aria-label', label);
    el.setAttribute('aria-controls', viewport.id);
    el.textContent = text; el.addEventListener('click', action);
    return el;
  };
  const mobile = matchMedia('(max-width: 800px)');
  // Reviews advance only when the visitor chooses.
  let page = 0;
  let firstVisible = 0;
  const size = () => mobile.matches ? 1 : 3;
  const pages = () => Math.ceil(cards.length / size());
  const dots = document.createElement('span'); dots.className = 'reviews-dots';
  const status = document.createElement('span'); status.className = 'reviews-status';
  status.setAttribute('aria-live', 'polite');
  status.setAttribute('aria-atomic', 'true');
  function render() {
    page = Math.min(page, pages() - 1);
    const start = Math.min(page * size(), Math.max(0, cards.length - size()));
    firstVisible = start;
    track.style.transform = mobile.matches ? 'none' : `translateX(-${start * 100 / size()}%)`;
    cards.forEach((card, i) => {
      const visible = i >= start && i < start + size();
      if (!visible && card.contains(document.activeElement)) viewport.focus({ preventScroll: true });
      card.inert = !visible;
      card.setAttribute('aria-hidden', String(!visible));
    });
    [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(page === i)));
    status.textContent = size() === 1 ? `${start + 1} of ${cards.length}` : `${start + 1}–${Math.min(start + size(), cards.length)} of ${cards.length}`;
    requestAnimationFrame(() => {
      // Reserve room for the longest quote at the current responsive width.
      const reviewHeight = Math.max(...cards.map(card => card.getBoundingClientRect().height));
      viewport.style.height = `${Math.ceil(reviewHeight)}px`;
    });
  }
  function go(next) {
    page = (next + pages()) % pages();
    if (mobile.matches) {
      viewport.scrollTo({ left: page * viewport.clientWidth,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    } else render();
  }
  function layout() {
    page = Math.min(Math.floor(firstVisible / size()), pages() - 1);
    dots.replaceChildren();
    for (let i = 0; i < pages(); i++) dots.append(button(`Show review group ${i + 1}`, '•', () => go(i)));
    render();
    viewport.scrollTo({ left: mobile.matches ? page * viewport.clientWidth : 0, behavior: 'instant' });
  }
  controls.append(button('Previous reviews', '←', () => go(page - 1)), status,
    button('Next reviews', '→', () => go(page + 1)), dots);
  // Controls stay in place while visitors browse quotes.
  viewport.after(controls);
  const swipeHint = document.createElement('p');
  swipeHint.className = 'carousel-hint';
  swipeHint.textContent = 'Swipe to explore more reviews';
  controls.after(swipeHint);
  viewport.addEventListener('keydown', (event) => {
    // Do not hide a focused source link by intercepting its arrow keys.
    if (event.target !== viewport) return;
    if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    if (event.key === 'Home') go(0);
    else if (event.key === 'End') go(pages() - 1);
    else go(page + (event.key === 'ArrowRight' ? 1 : -1));
  });
  // Native scrolling follows the finger; snapping settles on a whole review.
  let scrollTimer;
  viewport.addEventListener('scroll', () => {
    if (!mobile.matches) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      page = Math.max(0, Math.min(cards.length - 1, Math.round(viewport.scrollLeft / viewport.clientWidth)));
      render();
    }, 100);
  }, { passive: true });
  mobile.addEventListener('change', layout);
  const reviewSizing = new ResizeObserver(() => layout());
  cards.forEach(card => reviewSizing.observe(card));
  layout();
}
// Selected Instagram Reels use local covers and ordinary links; no third-party player is loaded.
const reels = document.querySelector('.life-reels');
if (reels) {
  const cards = [...reels.querySelectorAll('.life-reel')];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const controls = document.createElement('nav');
  controls.className = 'reel-controls';
  controls.setAttribute('aria-label', 'Browse Life at HIT videos');
  const previous = document.createElement('button');
  const next = document.createElement('button');
  const status = document.createElement('span');
  previous.type = next.type = 'button';
  previous.textContent = '←'; next.textContent = '→';
  previous.setAttribute('aria-label', 'Previous videos');
  next.setAttribute('aria-label', 'Next videos');
  status.className = 'reel-status';
  status.setAttribute('aria-live', 'polite');
  status.setAttribute('aria-atomic', 'true');
  controls.append(previous, status, next);
  reels.after(controls);
  const swipeHint = document.createElement('span');
  swipeHint.className = 'carousel-hint';
  swipeHint.textContent = 'Swipe to explore more videos';
  controls.append(swipeHint);
  function updateReels() {
    const scrollable = reels.scrollWidth > reels.clientWidth + 2;
    controls.hidden = !scrollable;
    // Only an overflowing gallery needs its own keyboard stop.
    reels.tabIndex = scrollable ? 0 : -1;
    previous.disabled = reels.scrollLeft < 2;
    next.disabled = reels.scrollLeft >= reels.scrollWidth - reels.clientWidth - 2;
    const bounds = reels.getBoundingClientRect();
    const visible = cards.map((card, i) => {
      const r = card.getBoundingClientRect();
      return (r.left + r.right) / 2 >= bounds.left && (r.left + r.right) / 2 <= bounds.right ? i + 1 : null;
    }).filter(Boolean);
    if (visible.length) status.textContent = `Video${visible.length > 1 ? 's' : ''} ${visible[0]}${visible.length > 1 ? `–${visible.at(-1)}` : ''} of ${cards.length}`;
  }
  function moveReels(direction) {
    const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : reels.clientWidth;
    const pageSize = matchMedia('(min-width:901px)').matches ? 3 : 1;
    reels.scrollBy({ left: direction * step * pageSize, behavior: reduced.matches ? 'instant' : 'smooth' });
  }
  previous.addEventListener('click', () => moveReels(-1));
  next.addEventListener('click', () => moveReels(1));
  reels.addEventListener('keydown', event => {
    if (event.target !== reels || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') moveReels(event.key === 'ArrowLeft' ? -1 : 1);
    else reels.scrollTo({ left: event.key === 'Home' ? 0 : reels.scrollWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
  });
  let scrollTimer;
  reels.addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(updateReels, 120); }, { passive: true });
  new ResizeObserver(updateReels).observe(reels);
  updateReels();
}


